import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DataFormatService } from '../../services/data-format.service';

@Component({
    selector: 'contact-link',
    templateUrl: './contact-link.component.html',
    styleUrls: ['./contact-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactLinkComponent {
  @Input() subject: any;
  @Input() textDecoration: boolean = true;
  @Input() color: string = 'inherit';
  public url = '';
  public name = '';

  constructor(private dataFormatter: DataFormatService) {}
  ngOnInit() {
    if (this.subject) {
      if (this.subject.__typename) {
        this.url = this.dataFormatter.formatLink(this.subject);
      } else {
        this.url = '#';
      }
      if (this.subject.name && this.subject.__typename!=='Sponsor') {
        this.name = this.subject.name;
      } else if (this.subject.nickname && this.subject.__typename=='Sponsor') {
        this.name = this.subject.nickname
      } else if (this.subject.__typename === 'CertificatedOutlet') {
        this.name = this.subject.organization?.name ?? 'Unknown Object';
      } else {
        this.name = 'Unknown Object';
      }
    }
  }
}
